import toast from "react-hot-toast";

const success = (message: string, id?: string): void => {
  toast.success(message, { id });
};

const error = (message: string, id?: string): void => {
  toast.error(message, { id });
};

const remove = (id: string): void => {
  toast.remove(id);
};

const dismiss = (id: string): void => {
  toast.dismiss(id);
};

const loading = (message: string): void => {
  toast.loading(message);
};

const promise = (callback: any, params: any): Promise<any> => {
  return toast.promise(callback, params);
};

const toastService = { success, error, remove, dismiss, loading, promise };

export { success, error, remove, dismiss, loading, promise };
export default toastService;
